import BadgeOutlined from "@mui/icons-material/BadgeOutlined";
import DoNotDisturbOnOutlined from "@mui/icons-material/DoNotDisturbOnOutlined";
import ListAltOutlined from "@mui/icons-material/ListAltOutlined";
import SettingsSuggestOutlined from "@mui/icons-material/SettingsSuggestOutlined";
import TimelineOutlined from "@mui/icons-material/TimelineOutlined";
import {lazy} from "react";
import type {Page, PageGroup} from "router/types";
import {ROLE_ADMIN, ROLE_SUPER_ADMIN, ROLE_USER} from "utils/roles";

const SenderNamePage = lazy(
  () => import("pages/messaging-account/sender-name/SenderNamePage"),
);
const CustomerOptOutPage = lazy(
  () => import("pages/messaging-account/customer-opt-out/CustomerOptOutPage"),
);
const UnitsHistoryPage = lazy(
  () => import("pages/messaging-account/units-history/UnitsHistoryPage"),
);
const WalletTransactionsPage = lazy(
  () => import("pages/messaging-account/transactions/TransactionsPage"),
);

const messagingAccountRoutes: Array<Page | PageGroup> = [
  {
    segment: "messaging-account",
    title: "Messaging Account",
    Icon: SettingsSuggestOutlined,
    children: [
      {
        segment: "sender-name",
        title: "Sender Names",
        Icon: BadgeOutlined,
        Component: SenderNamePage,
        roles: [ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_USER],
      },
      {
        segment: "customer-opt-out",
        title: "Customer Opt Out",
        Icon: DoNotDisturbOnOutlined,
        Component: CustomerOptOutPage,
        roles: [ROLE_SUPER_ADMIN, ROLE_ADMIN],
      },
      {
        segment: "units-history",
        title: "Units History",
        Icon: TimelineOutlined,
        Component: UnitsHistoryPage,
        roles: [ROLE_SUPER_ADMIN, ROLE_ADMIN],
      },
      {
        segment: "transactions",
        title: "Transactions",
        Icon: ListAltOutlined,
        Component: WalletTransactionsPage,
        roles: [ROLE_SUPER_ADMIN, ROLE_ADMIN],
      },
    ],
  },
];

export default messagingAccountRoutes;
